/**
 * Generate a URL-safe slug from an author name
 * @param {string} name - Author's full name (e.g., "Josh Hobson")
 * @returns {string} URL slug (e.g., "joshhobson")
 */
export function generateAuthorSlug(name) {
    if (!name || typeof name !== "string") return "";
    return name.toLowerCase().trim().replace(/\s+/g, ""); // Remove all whitespace
}

/**
 * Get the full author page URL path
 * @param {string} name - Author's full name
 * @returns {string} URL path (e.g., "/author/joshhobson")
 */
export function getAuthorPageUrl(name) {
    const slug = generateAuthorSlug(name);
    return slug ? `/author/${slug}` : "";
}
